module.exports = __webpack_public_path__ + "static/media/add exam info.b72804f9.svg";